import { doDelete, doGet, doPost } from "../request";
import { ListAdmin } from "models/list-admin";

export const adminDoGetListAdmins = async (listUuid: string) => {
  const listAdmins = await doGet<ListAdmin[]>(`/admin/list/${listUuid}/admins`);
  return listAdmins;
};

export const adminDoPostListAdmin = async (
  listUuid: string,
  adminUuid: string,
) => {
  const listAdmin = await doPost<ListAdmin>(`/admin/list/${listUuid}/admin`, {
    admin_uuid: adminUuid,
  });
  return listAdmin;
};

export const adminDoDeleteListAdmin = async (
  listUuid: string,
  listAdminUuid: string,
) => {
  await doDelete(`/admin/list/${listUuid}/admin/${listAdminUuid}`);
};
